module.exports = __webpack_public_path__ + "img/LOGO_institutionnel-vectoisé.ba790e1e.svg";